import { Button, Panel, Separator, Text } from "@nju/ui";

interface IDashboardPaymentCTABannerProps {
  isLoading: boolean;
  handleCancelPaymentSwitch: () => void;
}

export function DashboardPaymentCTABanner({
  isLoading,
  handleCancelPaymentSwitch,
}: IDashboardPaymentCTABannerProps) {
  return (
    <>
      <Panel iconName="spinner" title="zmiana metody płatności w trakcie">
        <Separator size="xs" tone="invisible" />
        <Text
          size={{
            "@onlyMobile": "m",
            "@fromTablet": "l",
          }}
        >
          Właśnie zmieniamy metodę płatności z{" "}
          <strong>BLIK lub płatności online</strong> na{" "}
          <strong>kartę płatniczą</strong>. Potrzebujemy jeszcze chwili.
        </Text>
        <Separator size="xs" tone="invisible" />
        <div className="flex flex-col-reverse gap-3 from-tablet:flex-row from-tablet:justify-between">
          <Button
            isLoading={isLoading}
            onPress={handleCancelPaymentSwitch}
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
            variant="secondary"
          >
            anuluj zlecenie zmiany
          </Button>
          <Button
            onPress={() => {
              return window.location.reload();
            }}
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
          >
            odśwież
          </Button>
        </div>
      </Panel>
      <Separator size="s" tone="invisible" />
    </>
  );
}
